export default __webpack_public_path__ + "static/media/segundologincuil.35a05b81.svg";